module.exports = __webpack_public_path__ + "static/media/Lineup_BackgroundPic.4a3f2089.jpg";